<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.rollcall'),
                        href: meta.links.attendance_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.attendance_group_show,
                    },
                    {
                        name: attendance.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-auto-animate>
            <AppButton element="InertiaLink" :href="meta.links.reload" v-if="meta.links.reload" desired-action>
                {{ $t('messages.reload_data_from_previous_rollcall') }}
            </AppButton>
        </div>

        <form action="" method="POST" @submit.prevent="submit">
            <div class="pt-3">
                <FormLabel :value="$t('messages.comment')" for="comment" />
                <FormTextarea
                    rows="3"
                    id="comment"
                    v-model="form.comment"
                    name="comment"
                    type="text"
                    class="mt-1 w-full"
                    style="min-height: 60px"
                />
                <FormError :value="form.errors.comment" class="mt-2" />
            </div>

            <div class="flex justify-end mt-3">
                <SubmitFormButton :button-text="$t('messages.rollcall')" :processing="form.processing" />
            </div>

            <div class="md:grid md:grid-cols-2 md:gap-6 mt-5">
                <div
                    class="relative col-span-1 flex shadow rounded-md"
                    v-for="student in form.student_attendance_details"
                    :key="student.id"
                >
                    <div
                        class="shrink-0 flex items-center justify-center w-24 text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                    >
                        <img :src="student.avatar_or_default" alt="profile photo" />
                    </div>
                    <div
                        class="flex-1 flex flex-col px-4 py-2 items-start justify-start border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                    >
                        <span class="text-sm leading-5">
                            <span v-if="student.is_birthday">🎂 </span>
                            {{ student.full_name }}
                        </span>
                        <StudentAttendanceDetailForm
                            v-model="student.data"
                            :delays="options.delays"
                            :justifications="options.justifications"
                            :student-attendance-details="student.student_attandance_details"
                        />
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-3">
                <SubmitFormButton :button-text="$t('messages.rollcall')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import StudentAttendanceDetailForm from '@/components/pageSpecific/StudentAttendanceDetailForm.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        FormTextarea,
        FormError,
        FormLabel,
        SubmitFormButton,
        PanelPage,
        StudentAttendanceDetailForm,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'attendance', 'students', 'group', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                student_attendance_details: this.attendance.student_attendance_details,
                comment: this.attendance.comment,
            }),
        };
    },
    methods: {
        submit() {
            this.form
                .transform((data) => {
                    data.student_attendance_details = data.student_attendance_details.map((s) => {
                        return s.data;
                    });
                    return data;
                })
                .post(this.meta.links.store);
        },
    },
};
</script>
